<template>
    <section class="main-content lottery-page pb-5">
        <div class="announce-bar" v-if="marquee_text">
            <div class="announce-bar__inner">
                <span class="announce-bar__label">
                    <i class="fa fa-bullhorn"></i>
                    ประกาศ
                </span>
                <div class="announce-bar__ticker">
                    <div class="announce-bar__track">
                        <span>{{ marquee_text }}</span>
                        <span>{{ marquee_text }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div
                class="lottery-content p-2 w-100 align-self-stretch"
                style="min-height: calc((100vh - 149.8px) - 50px);"
            >
                <div class="lotto-section xtarget col-lotto">
                    <div class="section-title-wrap">
                        <h3 class="section-title">
                            <router-link :to="{ name: 'lottery' }" class="section-back-link">แทงหวย</router-link>
                            <span class="section-separator">/</span>
                            <span>จับยี่กี</span>
                        </h3>
                    </div>

                    <div class="row">
                        <div
                            class="col-xs-6 col-sm-6 col-md-3 col-lg-3 lotto-type-box"
                            v-for="(value, index) in yeekee_redata"
                            :key="'yeekee-' + index"
                        >
                            <router-link
                                :to="{ name: 'yeekee', params: { round: value.round } }"
                                v-if="openRound(value.round)"
                            >
                                <div class="lotto-card lotto-card--equal">
                                    <div class="ribbon-lotto ribbon-lotto--gold">
                                        <i class="fa fa-trophy"></i>
                                    </div>

                                    <div class="lotto-head lotto-yeekee">
                                        <h5>หวยยี่กีรอบที่ {{ value.round }}</h5>
                                        <span class="badge badge-dark">ปิดรับ {{ value.expiration_date }}</span>
                                    </div>

                                    <div class="lotto-time text-success">
                                        <i class="fa fa-clock-o"></i>

                                        <vue-countdown-timer
                                            @start_callback="startCallBack('event started', value.round)"
                                            @end_callback="endCallBack('event closed', value.round)"
                                            :start-time="open_time"
                                            :end-time="value.close"
                                            :interval="1000"
                                        >
                                            <template slot="countdown" slot-scope="scope">
                                                <span class="countdown">{{ scope.props.hours }}:{{ scope.props.minutes }}:{{ scope.props.seconds }}</span>
                                            </template>
                                            <template slot="end-text" slot-scope="scope">
                                                <span class="countdown">อยู่ระหว่างการออกผล...</span>
                                            </template>
                                        </vue-countdown-timer>
                                    </div>
                                </div>
                            </router-link>

                            <router-link
                                :to="{ name: 'yeekee', params: { round: value.round } }"
                                v-else-if="openProgressRound(value.round)"
                            >
                                <div class="lotto-card lotto-card--equal lotto-progress">
                                    <div class="ribbon-lotto">
                                        <i class="fa fa-trophy"></i>
                                    </div>

                                    <div class="lotto-head lotto-yeekee">
                                        <h5>หวยยี่กีรอบที่ {{ value.round }}</h5>
                                        <span class="badge badge-dark">ปิดรับ {{ value.expiration_date }}</span>
                                    </div>

                                    <div class="lotto-time text-success">
                                        <i class="fa fa-clock-o"></i>

                                        <vue-countdown-timer
                                            @start_callback="startProgressCallBack('progress started', value.round)"
                                            @end_callback="endCallBack('event ended', value.round)"
                                            :start-time="round_start[value.round]"
                                            :end-time="value.end"
                                            :interval="1000"
                                        >
                                            <template slot="countdown" slot-scope="scope">
                                                <span class="countdown">อยู่ระหว่างการออกผล</span>
                                            </template>
                                            <template slot="end-text" slot-scope="scope">
                                                <span class="countdown">ปิดรับแทง</span>
                                            </template>
                                        </vue-countdown-timer>
                                    </div>
                                </div>
                            </router-link>

                            <router-link
                                :to="{ name: 'yeekee', params: { round: value.round } }"
                                v-else
                            >
                                <div class="lotto-card lotto-close lotto-card--equal">
                                    <div class="ribbon-lotto">
                                        <i class="fa fa-trophy"></i>
                                    </div>

                                    <div class="lotto-head lotto-yeekee">
                                        <h5>หวยยี่กีรอบที่ {{ value.round }}</h5>
                                        <span class="badge badge-dark">ปิดรับ {{ value.expiration_date }}</span>
                                    </div>

                                    <div class="lotto-time text-success">
                                        <i class="fa fa-ban"></i>
                                        <div>
                                            <span class="countdown">ปิดรับแทง</span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <b-nav-item :to="{ name: 'home' }" style="display:block" v-if="callNextround"></b-nav-item>
                <b-nav-item :to="{ name: 'home' }" style="display:block" v-else></b-nav-item>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'allyeekee',
    data () {
        return {
            allRound: {},
            start_time: '',
            current_time: '',
            round_start: {},
            next_round: 0,
            round_status: 0,
            open_time: '',
            yeekee_round: [],

            site_name: '',
            marquee_text: 'เว็บหวยออนไลน์ที่ดีที่สุด ยินดีต้อนรับค่ะ',
            marquee_array: [
                'ยินดีต้อนรับสู่',
                'เว็บหวยออนไลน์ที่ดีที่สุด สมาชิกที่มีปัญหาในการใช้งาน สามารถกดปุ่มไลน์เพื่อแจ้งปัญหาหรือสอบถามข้อมูลได้ค่ะ',
            ],

            yeekee_redata: [],
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            round: state => state.round.round,
            informations: state => state.information.informations
        }),
        ...mapGetters('information', ['getInformationCount', 'getAnnouceRecord', 'getMarqueeText']),
        callNextround: function () {
            return this.next_round
        },
    },
    methods: {
        async loadRound () {
            try {
                if (this.round.yeekees) {
                    this.allRound = this.round
                }
                else {
                    const response = await this.$store.dispatch('round/getAllRound')
                    this.allRound = response
                }

                let now = moment()
                this.current_time = moment()
                this.open_time = moment(now).hour(5).minute(0).second(0)

                for (let k in this.allRound.yeekees) {
                    this.round_start[k] = 0

                    let roundData = this.allRound.yeekees[k]
                    let [shh, smm] = roundData.startTime.split('.')
                    let [ehh, emm] = roundData.endTime.split('.')

                    if (k < 73) {
                        let new_start = moment(now).hour(shh).minute(smm).second(0)
                        this.allRound.yeekees[k].start = new_start
                        this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')

                        let new_end = moment(now).hour(ehh).minute(emm).second(0)
                        this.allRound.yeekees[k].end = new_end
                        this.allRound.yeekees[k].expiration_date = moment(new_end).format('HH:mm:ss')
                        this.allRound.yeekees[k].close = moment(new_end).subtract(1, 'seconds')
                    }
                    else {
                        let tomorrow = moment().add(1, 'days')

                        if (k == 73) {
                            let new_start = moment(now).hour(shh).minute(smm).second(0)
                            this.allRound.yeekees[k].start = new_start
                            this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')
                            ehh = (emm = 0)
                        }
                        else {
                            let new_start = moment(tomorrow).hour(shh).minute(smm).second(0)
                            this.allRound.yeekees[k].start = new_start
                            this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')
                        }

                        let new_end = moment(tomorrow).hour(ehh).minute(emm).second(0)
                        this.allRound.yeekees[k].end = new_end
                        this.allRound.yeekees[k].expiration_date = moment(new_end).format('HH:mm:ss')
                        this.allRound.yeekees[k].close = moment(new_end).subtract(1, 'seconds')
                    }
                }

                let yesterday = moment().subtract(1, 'days')
                let now2 = moment()
                let same_or_before = moment(now2).isSameOrBefore(this.allRound.yeekees[1].start)

                if (same_or_before) {
                    let open_yesterday = moment()
                    this.open_time = moment(open_yesterday).subtract(1, 'days')
                }

                for (let k in this.allRound.yeekees) {
                    let roundData = this.allRound.yeekees[k]
                    let [shh, smm] = roundData.startTime.split('.')
                    let [ehh, emm] = roundData.endTime.split('.')

                    if (same_or_before) {
                        if (k < 73) {
                            let new_start = moment(yesterday).hour(shh).minute(smm).second(0)
                            this.allRound.yeekees[k].start = new_start
                            this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')

                            let new_end = moment(yesterday).hour(ehh).minute(emm).second(0)
                            this.allRound.yeekees[k].end = new_end
                            this.allRound.yeekees[k].expiration_date = moment(new_end).format('HH:mm:ss')
                            this.allRound.yeekees[k].close = moment(new_end).subtract(1, 'seconds')
                        }
                        else {
                            let now3 = moment()
                            if (k == 73) {
                                let new_start = moment(yesterday).hour(shh).minute(smm).second(0)
                                this.allRound.yeekees[k].start = new_start
                                this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')
                                ehh = (emm = 0)
                            }
                            else {
                                let new_start = moment(now3).hour(shh).minute(smm).second(0)
                                this.allRound.yeekees[k].start = new_start
                                this.allRound.yeekees[k].start_date = moment(new_start).format('DD/MM/YYYY HH:mm:ss')
                            }

                            let new_end = moment(now3).hour(ehh).minute(emm).second(0)
                            this.allRound.yeekees[k].end = new_end
                            this.allRound.yeekees[k].expiration_date = moment(new_end).format('HH:mm:ss')
                            this.allRound.yeekees[k].close = moment(new_end).subtract(1, 'seconds')
                        }
                    }
                }

                let current_yeekee_time = moment()

                let reformat_ontime = []
                let reformat_outtime = []
                for (let k in this.allRound.yeekees) {
                    let yeekee_data = this.allRound.yeekees[k]
                    let next_end_time = moment(yeekee_data.end).add(15, 'minutes')

                    if (moment(current_yeekee_time).isAfter(next_end_time)) {
                        reformat_outtime.push(yeekee_data)
                    }
                    else {
                        reformat_ontime.push(yeekee_data)
                    }
                }
                this.yeekee_redata = reformat_ontime.concat(reformat_outtime)

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async checkActiveRound (round_id) {
            try {
                const response = await this.$store.dispatch('round/getRoundYeekeeByRoundId', round_id)
                this.round_status = response.status
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        openRound (round_id) {
            let in_period_status = moment().isBetween(this.open_time, this.allRound.yeekees[round_id].close)

            if (this.allRound.yeekees[round_id].status && in_period_status) {
                this.round_status = true
                if (this.round_status) {
                    return true
                }
            }
            return false
        },

        openProgressRound (round_id) {
            let in_period_status = moment().isBetween(this.allRound.yeekees[round_id].close, this.allRound.yeekees[round_id].end)

            if (this.allRound.yeekees[round_id].status && in_period_status) {
                this.round_status = true
                if (this.round_status) {
                    return true
                }
            }
            return false
        },

        startCallBack: function (x, y) {
            this.next_round = moment()
        },

        endCallBack: function (x, y) {
            let nex_round = parseInt(y) + 1
            this.round_start[nex_round] = moment()
            this.next_round = moment()
        },

        startProgressCallBack: function (x, y) {
            this.next_round = moment()
        },

        getNow () {
            let now = moment()
            return moment(now).format('DD/MM/YYYY HH:mm:ss')
        },
    },
    mounted () {
        this.site_name = process.env.VUE_APP_SITE

        if (typeof this.getMarqueeText !== 'undefined') {
            this.marquee_text = this.getMarqueeText.header
        }
    },
    created () {
        this.loadRound()
    },
    destroyed () {
    }
}
</script>

<style lang="css" scoped>
.main-content {
    margin-top: 0;
    border-radius: 0;
}

.lottery-page {
    background:
        radial-gradient(circle at top left, rgba(42, 110, 107, 0.07), transparent 24%),
        radial-gradient(circle at bottom right, rgba(26, 79, 75, 0.05), transparent 24%),
        linear-gradient(180deg, #eef3f2 0%, #e8eeee 100%);
}

/* ===== announce bar ===== */
.announce-bar {
    margin-top: 14px;
    margin-bottom: 18px;
}

.announce-bar__inner {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid rgba(26, 79, 75, 0.08);
    border-radius: 0 0 28px 28px;
    padding: 14px 18px;
    box-shadow: 0 12px 28px rgba(26, 79, 75, 0.08);
}

.announce-bar__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    color: #1A4F4B;
    font-weight: 800;
    font-size: 15px;
    line-height: 1;
}

.announce-bar__label i {
    font-size: 22px;
}

.announce-bar__ticker {
    position: relative;
    flex: 1;
    overflow: hidden;
    min-width: 0;
    height: 24px;
    display: flex;
    align-items: center;
}

.announce-bar__track {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    will-change: transform;
    animation: ticker-loop 18s linear infinite;
}

.announce-bar__track span {
    display: inline-block;
    padding-right: 80px;
    color: #e1453e;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
}

@keyframes ticker-loop {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
}

/* ===== utility ===== */
.p-2 {
    padding: 0.5rem !important;
}

.w-100 {
    width: 100% !important;
}

.align-self-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
}

.text-success {
    color: #1A4F4B !important;
}

.text-white {
    color: #fff !important;
}

.bg-black {
    background-image: linear-gradient(#1A4F4B, #0d2e2b) !important;
}

.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.lottery-content {
    background: transparent;
}

.col-lotto {
    margin-bottom: 22px;
}

.lotto-section {
    position: relative;
    overflow: hidden;
    padding: 18px 14px 12px;
    border-radius: 30px;

    background: linear-gradient(
        135deg,
        #1A4F4B 0%,
        #235E59 50%,
        #2A6E6B 100%
    );

    box-shadow: 0 16px 34px rgba(26, 79, 75, 0.18);
}

.lotto-section::before {
    content: "";
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.055);
    top: -40px;
    right: -38px;
    pointer-events: none;
}

.lotto-section::after {
    content: "";
    position: absolute;
    width: 140px;
    height: 140px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.035);
    left: -54px;
    bottom: -60px;
    pointer-events: none;
}

.section-title-wrap {
    position: relative;
    z-index: 1;
    margin-bottom: 12px;
    padding: 0 6px;
}

.section-title {
    margin: 0;
    color: #fff;
    font-size: 28px;
    font-weight: 900;
    line-height: 1.1;
    letter-spacing: -0.3px;
}

.section-back-link {
    color: #fff3a8;
    font-weight: 900;
    text-decoration: none;
}

.section-back-link:hover,
.section-back-link:focus {
    color: #fff7c7;
    text-decoration: none;
}

.section-separator {
    display: inline-block;
    margin: 0 6px;
    color: rgba(255, 255, 255, 0.7);
}

.row {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
}

.lotto-type-box {
    padding-right: 5px !important;
    padding-left: 5px !important;
    margin-bottom: 10px;
}

a,
a:hover,
a:focus {
    text-decoration: none;
}

/* ===== card ===== */
.lotto-card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border-radius: 24px;
    border: 2px solid rgba(255, 255, 255, 0.72);
    background: linear-gradient(180deg, #ffffff 0%, #f8fbfb 100%);
    box-shadow: 0 10px 22px rgba(26, 79, 75, 0.12);
    transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease, filter 0.18s ease;
}

.lotto-card--equal {
    height: 152px;
}

a:hover .lotto-card,
a:focus .lotto-card {
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(26, 79, 75, 0.14);
}

/* ===== state contrast ===== */
.lotto-card:not(.lotto-close):not(.lotto-off) {
    border-color: rgba(255, 255, 255, 0.92);
    box-shadow:
        0 12px 24px rgba(26, 79, 75, 0.14),
        inset 0 1px 0 rgba(255,255,255,0.10);
}

.lotto-progress {
    border-color: rgba(255, 248, 193, 0.92);
    box-shadow:
        0 12px 24px rgba(26, 79, 75, 0.14),
        0 0 0 1px rgba(255, 243, 168, 0.22) inset;
}

.lotto-progress .lotto-time {
    color: #8a6a00;
    background: linear-gradient(180deg, #fffdf2 0%, #fff8db 100%);
    border-top-color: #f0e4a9;
}

.lotto-progress .countdown {
    color: #8a6a00;
}

.lotto-close,
.lotto-off {
    opacity: 0.78;
    filter: saturate(0.68) brightness(0.96);
    border-color: rgba(220, 235, 234, 0.68);
    box-shadow: 0 6px 14px rgba(26, 79, 75, 0.06);
}

.lotto-close .lotto-head,
.lotto-off .lotto-head {
    color: rgba(255,255,255,0.76);
}

.lotto-close .badge-dark,
.lotto-off .badge-dark {
    background: rgba(42, 80, 78, 0.32);
    color: rgba(255,255,255,0.88);
}

.lotto-close .lotto-time,
.lotto-off .lotto-time {
    background: linear-gradient(180deg, #eef5f5 0%, #e7f0f0 100%);
    color: #2a6e6b;
    border-top-color: #cfe0df;
}

.lotto-close .ribbon-lotto,
.lotto-off .ribbon-lotto {
    background: rgba(255, 255, 255, 0.10);
    color: rgba(255,255,255,0.84);
}

/* ===== top icon ===== */
.ribbon-lotto {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
    backdrop-filter: blur(2px);
    box-shadow:
        inset 0 1px 0 rgba(255,255,255,0.16),
        0 2px 6px rgba(0,0,0,0.08);
    font-size: 17px;
}

.ribbon-lotto--gold {
    background: linear-gradient(180deg, #f7e08a 0%, #d4a62a 55%, #b98412 100%);
    color: #fff8dc;
    border: 1px solid rgba(255, 224, 130, 0.78);
    box-shadow:
        0 8px 18px rgba(185, 132, 18, 0.28),
        inset 0 1px 0 rgba(255,255,255,0.35);
}

/* ===== head ===== */
.lotto-head {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 1 auto;
    min-height: 96px;
    padding: 13px 12px 10px;
    color: #fff;
    text-align: left;
    text-shadow: rgba(0, 0, 0, 0.10) 0 1px 1px;
}

.lotto-head h5 {
    margin: 0 34px 8px 0;
    font-size: 15px;
    font-weight: 800;
    line-height: 1.24;
    min-height: 32px;
    letter-spacing: -0.2px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

/* ===== badge ===== */
.badge-dark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    color: #ffffff;
    background: rgba(26, 79, 75, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 999px !important;
    font-family: unset !important;
    font-size: 13px;
    font-weight: 800;
    padding: 5px 12px;
    line-height: 1;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.06);
    letter-spacing: 0.1px;
}

/* ===== footer ===== */
.lotto-time {
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 11px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fcfc 100%);
    border-top: 1px solid #cfe0df;
    font-size: 12px;
    line-height: 1.1;
    color: #1A4F4B;
    font-weight: 800;
}

.lotto-time i {
    flex-shrink: 0;
    font-size: 14px;
    opacity: 0.95;
}

.lotto-time span {
    display: inline-block;
    line-height: 1;
}

.countdown {
    font-size: 16px;
    font-weight: 900;
    letter-spacing: 0.8px;
}

.lotto-yeekee {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0)),
        linear-gradient(135deg, #2A8C87 0%, #1A6B66 100%);
}

.lotto-close .lotto-yeekee,
.lotto-off .lotto-yeekee {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0)),
        linear-gradient(135deg, #3a6b68 0%, #4a7b78 100%);
}

@media (min-width: 768px) {
    .lotto-card--equal {
        height: 154px;
    }

    .lotto-head {
        min-height: 98px;
    }
}

@media (max-width: 767px) {
    .announce-bar {
        margin-top: 12px;
        margin-bottom: 18px;
    }

    .announce-bar__inner {
        padding: 12px 16px;
        border-radius: 0 0 26px 26px;
    }

    .announce-bar__label {
        font-size: 14px;
    }

    .announce-bar__label i {
        font-size: 20px;
    }

    .announce-bar__ticker {
        height: 22px;
    }

    .announce-bar__track span {
        font-size: 14px;
        padding-right: 64px;
    }

    .lotto-section {
        padding: 16px 10px 10px;
        border-radius: 28px;
    }

    .section-title-wrap {
        margin-bottom: 10px;
        padding: 0 8px;
    }

    .section-title {
        font-size: 26px;
    }

    .lotto-type-box {
        padding-right: 4px !important;
        padding-left: 4px !important;
        margin-bottom: 8px;
    }

    .lotto-card {
        border-radius: 22px;
    }

    .lotto-card--equal {
        height: 150px;
    }

    .ribbon-lotto {
        width: 38px;
        height: 38px;
        top: 10px;
        right: 10px;
        font-size: 16px;
    }

    .lotto-head {
        min-height: 94px;
        padding: 13px 12px 10px;
    }

    .lotto-head h5 {
        margin-right: 34px;
        margin-bottom: 8px;
        font-size: 13px;
        min-height: 32px;
    }

    .badge-dark {
        font-size: 9px;
        padding: 5px 12px;
    }

    .lotto-time {
        min-height: 44px;
        padding: 8px 11px;
        font-size: 12px;
    }

    .lotto-time i {
        font-size: 14px;
    }

    .countdown {
        font-size: 16px;
        font-weight: 900;
        letter-spacing: 0.5px;
    }
}
</style>